<template>
    <div class="pa-0">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <v-form
                id="surveyForm"
                ref="surveyForm"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                name="surveyForm"
                action="/order-details/"
                method="POST"
                @submit.prevent="handleSubmit(handleSubmission)"
            >
                <input
                    id="form-name"
                    type="hidden"
                    name="form-name"
                    value="surveyForm"
                />
                <input
                    id="email"
                    type="hidden"
                    name="email"
                    :value="webUser && webUser.email"
                />
                <input
                    id="webOrderNo"
                    type="hidden"
                    name="webOrderNo"
                    :value="webOrderNo"
                />

                <div class="mb-4">
                    <ValidationProvider
                        name="experienceRating"
                        rules="between:1,5"
                        class="validationWrapper"
                    >
                        <div slot-scope="{ errors }">
                            <span class="validationMessage">
                                {{ errors[0] }}
                            </span>
                            <p class="mb-0">
                                <TranslatableStringComponent :tstring="{string: 'shoppingExperience'}" />
                            </p>
                            <div class="d-flex">
                                <v-rating
                                    v-model="experienceRating"
                                    color="yellow darken-3"
                                    background-color="grey lighten-1"
                                    empty-icon="$ratingFull"
                                    hover
                                    small
                                ></v-rating>
                                <span class="pa-1">{{ experienceRating }}</span>
                            </div>
                            <input
                                id="experienceRating"
                                v-model="experienceRating"
                                type="hidden"
                                name="experienceRating"
                            />
                        </div>
                    </ValidationProvider>
                </div>
                <div class="mb-4">
                    <ValidationProvider
                        name="recommedationRating"
                        rules="between:1,5"
                        class="validationWrapper"
                    >
                        <div slot-scope="{ errors }">
                            <span class="validationMessage">
                                {{ errors[0] }}
                            </span>
                            <p class="mb-0">
                                <TranslatableStringComponent :tstring="{string: 'recommendSite'}" />
                            </p>
                            <div class="d-flex">
                                <v-rating
                                    v-model="recommedationRating"
                                    color="yellow darken-3"
                                    background-color="grey lighten-1"
                                    empty-icon="$ratingFull"
                                    hover
                                    small
                                ></v-rating>
                                <span class="pa-1">{{
                                    recommedationRating
                                }}</span>
                            </div>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="mb-4">
                    <ValidationProvider
                        name="buyAgainRating"
                        rules="between:1,5"
                        class="validationWrapper"
                    >
                        <div slot-scope="{ errors }">
                            <span class="validationMessage">
                                {{ errors[0] }}
                            </span>
                            <p class="mb-0">
                                <TranslatableStringComponent :tstring="{string: 'buyAgain'}" />
                            </p>
                            <div class="d-flex">
                                <v-rating
                                    v-model="buyAgainRating"
                                    color="yellow darken-3"
                                    background-color="grey lighten-1"
                                    empty-icon="$ratingFull"
                                    hover
                                    small
                                ></v-rating>
                                <span class="pa-1">{{ buyAgainRating }}</span>
                            </div>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="mb-4">
                    <ValidationProvider
                        name="followUpRequest"
                        rules="required"
                        class="validationWrapper"
                    >
                        <div slot-scope="{ errors }">
                            <span class="validationMessage">
                                {{ errors[0] }}
                            </span>
                            <p class="mb-0">
                                <TranslatableStringComponent :tstring="{string: 'followUpForOrderSatisfaction'}" />
                            </p>
                            <v-radio-group
                                v-model="followUpRequest"
                                class="mt-0 pl-2"
                                row
                            >
                                <v-radio
                                    :label="localize('yes')"
                                    value="Yes"
                                ></v-radio>
                                <v-radio
                                    :label="localize('no')"
                                    value="No"
                                ></v-radio>
                            </v-radio-group>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="mb-4">
                    <ValidationProvider
                        name="message"
                        rules=""
                        class="validationWrapper"
                    >
                        <div slot-scope="{ errors }">
                            <span class="validationMessage">
                                {{ errors[0] }}
                            </span>
                            <v-textarea
                                id="message"
                                v-model="message"
                                name="message"
                                :label="localize('message')"
                                outlined
                                dense
                                :hide-details="true"
                            ></v-textarea>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="mb-4">
                    <v-btn
                        type="submit"
                        color="primary"
                        :loading="loading"
                        right
                        @click="scrollIntoView()"
                        ><TranslatableStringComponent :tstring="{string: 'submit'}" /></v-btn
                    >
                    <div v-if="sending">
                        <TranslatableStringComponent :tstring="{string: 'submittingContactForm'}" />
                    </div>
                    <div v-if="waiting">
                        <TranslatableStringComponent :tstring="{string: 'awaitingContactForm'}" />
                    </div>
                    <div v-if="success">
                        <TranslatableStringComponent :tstring="{string: 'successfulContactForm'}" />
                    </div>
                    <div v-if="failure">
                        <TranslatableStringComponent :tstring="{string: 'failedContactForm'}" />
                    </div>
                </div>
            </v-form>
        </ValidationObserver>
        <v-btn
            icon
            style="position: absolute; top: 8px; right: 8px"
            @click="closeDialog()"
        >
            <fa
                :icon="['fal', 'times-circle']"
                class="fa-lg"
                style="color: #999ba3; font-size: 28px"
            />
        </v-btn>
    </div>
</template>
<script>
import { createHelpers } from 'vuex-map-fields'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapState } from 'vuex'
import { required, between } from 'vee-validate/dist/rules'
import { mask } from 'vue-the-mask'
// import { gtmEvent } from '~/plugins/global'
import encodeFormData from '~/mixins/encodeFormData'
import handleRecaptcha from '~/mixins/handleRecaptcha'
import handleSnackbar from '~/mixins/handleSnackbar'
import scrollIntoView from '~/mixins/scrollIntoView'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

const { mapFields } = createHelpers({
    getterType: 'getSurveyField',
    mutationType: 'updateSurveyField',
})

export default {
    name: 'FormSurvey',
    components: {
        ValidationProvider,
        ValidationObserver,
        TranslatableStringComponent,
    },
    directives: {
        mask,
    },
    mixins: [encodeFormData, handleRecaptcha, handleSnackbar, scrollIntoView],
    props: {
        webOrderNo: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            sending: false,
            waiting: false,
            success: false,
            failure: false,
            loading: false,
        }
    },
    computed: {
        ...mapState('formSelectOptions', ['queryOptions']),
        ...mapState('auth', ['webUser']),
        ...mapFields('survey', [
            'experienceRating',
            'recommedationRating',
            'buyAgainRating',
            'message',
            'followUpRequest',
        ]),
    },
    methods: {
        handleSubmission() {
            this.loading = true
            this.sending = true
            this.waiting = false
            this.success = false
            this.failure = false
            const axiosConfig = {
                header: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
            // console.log('ROUTE!', this.$route)
            this.$axios
                .post(
                    process.env.V2_BASE_URL + '/order-details/',
                    this.encode({
                        'form-name': 'surveyForm',
                        email: this.webUser && this.webUser.email,
                        webOrderNo: this.webOrderNo,
                        ...this.$store.state.survey.surveyForm,
                    }),
                    axiosConfig
                )
                .then((res) => {
                    // console.log('NETLIFY RESPONSE:', res)
                    // IF SUCCESS, SENDING=FALSE, AWAITING=TRUE
                    this.handleSuccess(
                        'thankYouForSubmittingYourFeedback'
                    )
                    // this.$axios
                    //     .post(
                    //         'submitted-web-form',
                    //         res.config.data,
                    //         axiosConfig
                    //     )
                    //     .then((response) => {
                    //         // console.log('LAMBDA RESPONSE:', response)
                    //         gtmEvent({
                    //             gtm: this.$gtm,
                    //             event: 'surveyForm',
                    //             eventType: 'form',
                    //             atts: {
                    //                 ...this.$store.state.survey.surveyForm
                    //             }
                    //         })
                    //         this.resetForm('surveyForm')
                    //         this.waiting = false
                    //         this.success = true
                    //     })
                    //     .catch((error) => {
                    //         console.log('lambda failure was', error.response)
                    //         this.handleErrors()
                    //     })
                })
                .catch((err) => {
                    console.log(
                        'This order submission failed at Netify for some reason. Please try again. ERROR:',
                        err
                    )
                    this.handleErrors(
                        'errorOccuredPleaseTryAgainAfterSometime'
                    )
                })
                .finally(() => {
                    setTimeout(() => {
                        this.success = false
                        this.failure = false
                    }, 3500)
                })
        },
        handleSuccess(successMessage) {
            this.loading = false
            this.sending = false
            this.waiting = false
            this.failure = false
            this.success = true
            this.clearRatings()
            this.resetForm('surveyForm')
            this.hitSnackbar({ string: successMessage }, {})
        },
        handleErrors(errorMessage) {
            this.loading = false
            this.sending = false
            this.waiting = false
            this.success = false
            this.failure = true
            this.hitSnackbar({ string: errorMessage }, {})
        },
        clearRatings() {
            this.experienceRating = 0
            this.recommedationRating = 0
            this.buyAgainRating = 0
        },
        closeDialog() {
            this.clearRatings()
            this.resetForm('surveyForm')
            this.$emit('closeDialog', false)
        },
    },
}
</script>
